import { Schema as S } from "effect";
export const Schema = S.TemplateLiteral(S.Literal("in_"), S.String).pipe(S.brand("@open-revenue/schema/stripe/InvoiceId"), S.annotations({
    identifier: "@open-revenue/schema/stripe/InvoiceId",
    description: "The id of the invoice in Stripe",
    examples: [
        "in_1234567890"
    ]
}));
export const make = (invoiceId)=>S.decodeUnknown(Schema)(invoiceId);
export const makeUnsafe = (invoiceId)=>invoiceId;
